<template>
    <div class="template-item bg-[#F5F7FA]" @click="useTemplate" draggable="true" @dragstart="onDragStart">
        <!-- {{ template.previewUrl }} -->
        <img v-if="!isSvgPreview"
            :src="template.preview_url + '?x-oss-process=image/resize,w_800/quality,q_80/format,webp'" alt=""
            class="template-image">
        <img v-else :src="template.preview_url" alt="" class="template-image svg-preview">
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive, computed } from 'vue';
import { useSdkStore } from '@/stores/sdk'
import { ElMessageBox } from 'element-plus'

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
const props = defineProps<{
    template?: any,
}>()

// 计算属性：判断是否为SVG预览
const isSvgPreview = computed(() => {
    if (!props.template?.preview_url) return false;
    const url = props.template.preview_url.toLowerCase();
    return url.endsWith('.svg') || url.includes('.svg?') || url.includes('format=svg');
});
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()
const islogin = userStore.isLoggedIn
const useTemplate = async () => {
    if (!islogin) {
        try {
            await ElMessageBox.confirm(
                '您还未登录，请先登录后再使用模板功能',
                '登录提示',
                {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }
            )
                // 用户点击"去登录"，跳转到登录页面
                ; (window as any).openGlobalLogin?.()
        } catch {
            // 用户点击"取消"或关闭对话框，不做任何操作
            return
        }
        return
    };
    let preview_url = props.template.preview_url
    let templates = (props.template.file_urls ? props.template.file_urls : preview_url).split(',')

    for (let i = 0; i < templates.length; i++) {
        await useMaterialTemplate(templates[i])
    }
}

const useMaterialTemplate = async (item) => {
    const fileSuffix = item.split('.').pop()
    if (['jpg', 'jpeg', 'png', 'webp', 'svg'].includes(fileSuffix)) {
        desginsdk.addElement.createImageElement(item)
        return
    }
    desginsdk.designOpt.requireFile(item)
    // desginsdk.addElement.createImageElement(item)
    // 
}

const onDragStart = (event: DragEvent) => {
    try {
        const t = props.template || {}
        const preview = t.preview_url || ''
        const urlList = (t.file_urls ? String(t.file_urls) : String(preview))
        const urls = urlList.split(',').map((s: string) => s.trim()).filter(Boolean)
        const primary = urls[0] || ''
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'copy'
            const payload = {
                type: 'material',
                kind: 'image',
                urls,
                primary
            }
            event.dataTransfer.setData('application/x-aimotu-drag', JSON.stringify(payload))
            if (primary) event.dataTransfer.setData('text/uri-list', primary)
        }
    } catch { }
}
</script>
<style lang="scss" scoped>
.template-item {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;
    position: relative;
    aspect-ratio: 1;
    width: 100%;
    height: 90px;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        transition: all 0.3s ease;
    }
}

.template-item:hover {
    .template-image {
        transform: scale(1.1);
        transition: all 0.3s ease;
    }
}

.template-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: all 0.3s ease;
}

.svg-preview {
    /* SVG特定样式 */
    background-color: #f8f9fa;
    padding: 8px;
    box-sizing: border-box;
}

.bigimg {
    width: 100%;
    height: 250px;
}
</style>
